import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconExtensionComponent } from "./med-icon-extension.component";

@NgModule({
  declarations: [
    MedIconExtensionComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconExtensionComponent,
  ],
})
export class MedIconExtensionModule { }
